import { render } from "./EliminarCuentabye.vue?vue&type=template&id=4a4076ae"
import script from "./EliminarCuentabye.vue?vue&type=script&lang=js"
export * from "./EliminarCuentabye.vue?vue&type=script&lang=js"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__